import React from 'react'
import AssistChip from 'components/Luxkit/Chips/AssistChip'
import styled from 'styled-components'
import { fadeIn } from 'components/utils/animations'
import { rem } from 'polished'
import { useAppSelector } from 'hooks/reduxHooks'
import { isLoggedIn } from 'selectors/accountSelectors'
import { ChatActions, MessageMetaPayload } from 'api/support'

export const ActionsList = styled.div`
  display: flex;
  flex-wrap: wrap-reverse;
  flex-direction: row-reverse;
  align-content: end;
  gap: ${rem(8)};
  width: 100%;
  margin-top: ${rem(12)};
`

const StyledAssistChip = styled(AssistChip)`
  animation: ${fadeIn} 1s;
`

interface Props {
  action: any,
  handleAction: (message: string, meta: any) => void,
  payload?: MessageMetaPayload,
  label?: string
}

function Action({ action, payload, handleAction }: Props) {
  const userIsLoggedIn = useAppSelector(isLoggedIn)

  const handleClick = (actionItem: any) => {
    if (actionItem?.action?.key === ChatActions.RESET_PASSWORD_SENT && !userIsLoggedIn && !payload?.inputPayload) {
      handleAction(actionItem?.text, { key: ChatActions.RESET_PASSWORD_REQUEST_EMAIL })
      return
    }

    handleAction(actionItem?.text, { key: actionItem?.action?.key, payload })
  }

  return (
    <StyledAssistChip
      variant="filled"
      size="medium"
      onClick={() => handleClick(action)}
    >
      {action?.text}
    </StyledAssistChip>
  )
}

export default Action
